import { createSelector } from 'reselect';

import { emptyObj } from '@beef/utils';

const mapCriticalType = (v) => {
  switch (v) {
    case 'red':
      return 'alert';
    case 'yellow':
      return 'warning';
    case 'grey':
    default:
      return 'information';
  }
};

const getHomeState = (state) => state.home;
const getAppState = (state) => state.application;

const getAppSettings = (state) => getAppState(state).settings;
const getAccountStatus = (state) => getHomeState(state).status;
const getAccountStatusInfo = (state) => getAccountStatus(state).data;
const getProfileSummaryData = (state) => getHomeState(state).profileSummary?.data || emptyObj;

const getTariffsBlock = (state) => getHomeState(state).tariffsBlock || emptyObj;
const getTariffsBlockContent = (state) => getTariffsBlock(state).content || emptyObj;
export const getTariffsBlockShow = (state) => getTariffsBlock(state).showBlock;
export const getTariffsBlockTitle = (state) => getTariffsBlockContent(state).title;
export const getTariffsBlockDescription = (state) => getTariffsBlockContent(state).description;
export const getTariffsBlockBtnText = (state) => getTariffsBlockContent(state).btnText;
export const getTariffsBlockUrl = (state) => getTariffsBlockContent(state).href;

export const getBalance = (state) => getHomeState(state).balance?.data?.balance || emptyObj;
export const getTotalRcRate = (state) => getProfileSummaryData(state).rcRate;
export const getPricePeriod = (state) => getHomeState(state).convergence?.data?.pricePeriod || 'в месяц';
export const getIsConvergenceUnavailableForYourRegion = (state) => getHomeState(state).convergence?.data?.presetTag === 'Y';

export const getTopAlertHeading = (state) => getAccountStatusInfo(state)?.topAlertHeaderHtmlText;
export const getTopAlertMessage = (state) => getAccountStatusInfo(state)?.topAlertMessageHtmlText;
export const getIsWeakPassword = (state) => getAppSettings(state).isWeakPassword;
export const getAccountErrorType = (state) => getAccountStatus(state).error?.type;
export const getChangeStatusFlag = (state) => getAccountStatusInfo(state).canChangeStatus;
export const getAccountCriticalType = (state) => getAccountStatusInfo(state).criticalType;

export const getShowAccountStatus = createSelector(
  getTopAlertHeading,
  getTopAlertMessage,
  (heading, message) => Boolean(heading || message),
);

export const getShouldRenderAccStatusBlock = createSelector(
  getAccountErrorType,
  getIsWeakPassword,
  getShowAccountStatus,
  (errorType, isWeakPassword, showAccStatus) => !errorType && (showAccStatus || isWeakPassword),
);

export const getAccBlockColorTheme = createSelector(
  getChangeStatusFlag,
  getAccountCriticalType,
  (canChangeStatus, criticalType) => {
    if (criticalType) {
      return mapCriticalType(criticalType);
    }

    return canChangeStatus ? 'attention' : 'alert';
  },
);
